<div class="site-page-header-ghost-wrapper">
    <nz-page-header [nzGhost]="false">
        <nz-page-header-title class="ml4">Plans </nz-page-header-title>
        <nz-page-header-extra class="mr4">
            <button nz-button nzType="primary" [routerLink]="['add']" [queryParams]="{index: index}" routerLinkActive="router-link-active"
                class="submitoraddbutton">
                Add Plan
            </button>
        </nz-page-header-extra>
    </nz-page-header>
</div>
<div nz-row nzJustify="end" class="mt4">
    <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24" class="mb5">
        <nz-input-group [nzSuffix]="suffixIconSearch">
            <input type="text" nz-input placeholder="Search by Plans name" ngModel
                (ngModelChange)="searchUsers($event)" />
        </nz-input-group>
        <ng-template #suffixIconSearch>
            <i nz-icon nzType="search"></i>
        </ng-template>
    </div>
</div>
<nz-tabset (nzSelectedIndexChange)="changeIndex($event)" [nzSelectedIndex]="index" >
    <nz-tab  nzTitle="Approved Plans">
        <nz-table #subjectTbl [nzData]="allApprovedPlans" [nzLoading]="loading" [nzTotal]="totalApprovedDataCount"
            [(nzPageSize)]="pageSize" [nzPageIndex]="pageIndex" [nzFrontPagination]="false"
            (nzQueryParams)="onQueryParamsChange($event)" nzShowSizeChanger [nzScroll]="{ x: '900px' }"
            *ngIf="listView && index === 0">
            <thead>
                <tr>
                    <th nzColumnKey="name" [nzSortFn]="true">Plan Name</th>
                    <th>Description</th>
                    <th nzWidth="350px">Information</th>
                    <th nzWidth="120px">Status</th>
                    <th class="text-right" nzWidth="150px">Action</th>
                </tr>
            </thead>
            <tbody cdkDropList (cdkDropListDropped)="onDropApproved($event)">
                <tr *ngFor="let data of allApprovedPlans; index as i" cdkDrag style="cursor: grab;">
                    <td>
                        <i nz-icon nzType="drag" nzTheme="outline" style="margin-right: 8px;"></i>
                        <span *ngIf="data.name  "> {{ data.name }} </span>
                    </td>
                    <td><span class="ellipsis" *ngIf="data.description " [innerHTML]=" data.description "></span></td>

                    <td>
                        <b>price</b> :<span *ngIf="data.price "> {{ data.price }}₹</span><br>
                        <b>Duration</b> :<span *ngIf="data.duration "> {{ data.duration }}(Days)</span><br>
                        <b>Test-Series</b> :<span *ngIf="data.testSeries && data.testSeries.length "> {{
                            data.testSeries.length }}</span><br>
                        <b>Max Selected Test-Series Per Plan</b> :<span *ngIf="data.max "> {{ data.max }}</span>
                    </td>
                    <!-- <td><span *ngIf="data.createdAt">{{ data.createdAt | date : "mediumDate" }}</span></td> -->

                    <td><span class="{{data.status? 'active' : 'inactive' }} status"></span></td>
                    <td class="action-buttons">
                        <a nz-button  nzTooltipTitle="Edit" nzTooltipPlacement="topCenter" nz-tooltip
                            [routerLink]="['update', data._id]" [queryParams]="{index: index}" routerLinkActive="router-link-active"><i nz-icon
                                nzType="form" nzTheme="outline"></i></a>
                        <a nz-button  nzTooltipTitle="Details" nzTooltipPlacement="topCenter" nz-tooltip
                            (click)="openPlanDetails(data)" routerLinkActive="router-link-active"><i nz-icon
                                nzType="eye" nzTheme="outline"></i></a>
                        <a *ngIf="userRole !== 'subAdmin'" class="action-button" nz-button nz-popconfirm
                            nzPopconfirmTitle="Are you sure {{data.status ? 'deActive' : 'active'}} this Plan?"
                            (nzOnConfirm)="updateStatus(data._id, data.status)"
                            nzTooltipTitle="{{data.status ? 'Deactive' : 'Active'}}" nzTooltipPlacement="topRight"
                            nz-tooltip><i nz-icon [nzType]="data.status ? 'stop' : 'check'" nzTheme="outline"></i></a>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </nz-tab>
    <nz-tab  nzTitle="Un-approved Plans">
        <nz-table #subjectTbl [nzData]="allPlans" [nzLoading]="loading" [nzTotal]="totalDataCount"
            [(nzPageSize)]="pageSize" [nzPageIndex]="pageIndex" [nzFrontPagination]="false"
            (nzQueryParams)="onQueryParamsChange($event)" nzShowSizeChanger [nzScroll]="{ x: '900px' }"
            *ngIf="listView && index === 1">
            <thead>
                <tr>
                    <th nzColumnKey="name" [nzSortFn]="true">Plan Name</th>
                    <th>Description</th>
                    <th nzWidth="350px">Information</th>
                    <th nzWidth="150px">
                        Created By
                    </th>
                    <th nzWidth="200px">
                        Rejected Reason
                    </th>
                    <th nzWidth="120px">Status</th>
                    <th class="text-right" nzWidth="150px">Action</th>
                </tr>
            </thead>
            <tbody cdkDropList (cdkDropListDropped)="onDropUnapproved($event)">
                <tr *ngFor="let data of allPlans; index as i" cdkDrag style="cursor: grab;">
                    <td>
                        <i nz-icon nzType="drag" nzTheme="outline" style="margin-right: 8px;"></i>
                        <span *ngIf="data.name  "> {{ data.name }} </span>
                    </td>
                    <td><span class="ellipsis" *ngIf="data.description " [innerHTML]=" data.description "></span></td>
                    <td>
                        <b>price</b> :<span *ngIf="data.price "> {{ data.price }}₹</span><br>
                        <b>Duration</b> :<span *ngIf="data.duration "> {{ data.duration }}(Days)</span><br>
                        <b>Test-Series</b> :<span *ngIf="data.testSeries && data.testSeries.length "> {{
                            data.testSeries.length }}</span><br>
                        <b>Max Selected Test-Series Per Plan</b> :<span *ngIf="data.max "> {{ data.max }}</span>
                    </td>
                    <!-- <td><span *ngIf="data.createdAt">{{ data.createdAt | date : "mediumDate" }}</span></td> -->

                    <td><span *ngIf="data.createdBy?.role === 'subAdmin'">
                            {{ data?.createdBy?.name }}
                        </span></td>
                    <td><span *ngIf="data.rejectionReason" class="ellipsis">{{data.rejectionReason}}</span></td>
                    <td>
                        <nz-tag
                            [nzColor]="data.approveStatus === 'approved' ? 'green':  data.approveStatus === 'pending'? 'lime':'volcano' ">
                            {{data.approveStatus}}

                        </nz-tag>
                    </td>
                    <!-- <td><span class="{{data.status? 'active' : 'inactive' }} status"></span></td> -->
                    <td class="action-buttons">
                        <a nz-button  nzTooltipTitle="Edit" nzTooltipPlacement="topCenter" nz-tooltip
                            [routerLink]="['update', data._id]" [queryParams]="{index: index}" routerLinkActive="router-link-active"><i nz-icon
                                nzType="form" nzTheme="outline"></i></a>
                        <a *ngIf="userRole !== 'subAdmin'" class="action-button" nz-button nz-popconfirm
                            nzPopconfirmTitle="Are you sure {{data.status ? 'deActive' : 'active'}} this chapter?"
                            (nzOnConfirm)="updateStatus(data._id, data.status)"
                            nzTooltipTitle="{{data.status ? 'Deactive' : 'Active'}}" nzTooltipPlacement="topRight"
                            nz-tooltip><i nz-icon [nzType]="data.status ? 'stop' : 'check'" nzTheme="outline"></i></a>
                        <a *ngIf="userRole !== 'subAdmin' " class="action-button top-margin" nz-button nz-popconfirm
                            nzPopconfirmTitle="Are you sure Approved this chapter?"
                            (nzOnConfirm)="updatePendingStatus(data._id, data.approveStatus)"
                            nzTooltipTitle="{{'Approve'}}" nzTooltipPlacement="topRight" nz-tooltip><i nz-icon
                                nzType="file-done" nzTheme="outline"></i></a>
                        <a *ngIf="userRole !== 'subAdmin' && data.approveStatus !== 'rejected'"
                            class="action-button top-margin delete" nz-button nz-popconfirm
                            nzPopconfirmTitle="Are you sure Reject this chapter?"
                            (nzOnConfirm)="openRejectionReason(data._id, data.approveStatus)" nzTooltipTitle='Reject'
                            nzTooltipPlacement="topRight" nz-tooltip><i nz-icon [nzType]="'close-circle'"
                                nzTheme="fill"></i></a>

                    </td>
                </tr>
            </tbody>
        </nz-table>
    </nz-tab>
</nz-tabset>